module.exports = __webpack_public_path__ + "static/img/Clay-Shirky.74c971b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/speakers/photo/Clay-Shirky.jpg
// module id = 607
// module chunks = 1